<template>
      <div class="filter">
        <input type="text" v-model="inputFilter" placeholder="Search"/>
         <font-awesome-icon :icon="[ 'fas', 'search' ]" />
        </div>
</template>
<script>
import {debounce} from '../../helpers';

export default {
  name: 'app',
  props: {},
  components: {},
  data: function() {
      return  {
        // watcher for the input element
        inputFilter: '',
        // the 'debounced' input value
        debouncedInput: '',
      }
  },
  watch: {
    inputFilter: debounce(function (newVal) {
      this.debouncedInput = newVal;
      this.$emit('inputFilter', this.debouncedInput)
    }, 300)
  }
}

</script>
